import { Arrays } from "@opendaw/lib-std";
import { AbstractModuleAdapter } from "../abstract";
import { Direction, ModuleConnectorAdapter } from "../connector";
export class ModularAudioOutputAdapter extends AbstractModuleAdapter {
    #voltageInput;
    constructor(context, box) {
        super(context, box);
        this.#voltageInput = ModuleConnectorAdapter.create(context.boxAdapters, box.input, Direction.Input, "Input");
    }
    get voltageInput() { return this.#voltageInput; }
    get inputs() {
        return [this.#voltageInput];
    }
    get outputs() {
        return Arrays.empty();
    }
}
